import { Injectable, EventEmitter } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SharedService {

  public static instance: SharedService = null;
  showTemplate = new EventEmitter<boolean>();
  admin = new EventEmitter<boolean>();
  repres = new EventEmitter<boolean>();
  client = new EventEmitter<boolean>();
  
  constructor(
  ) {
    return SharedService.instance = SharedService.instance || this;
   }

   public static getInstance() {
     if (this.instance == null) {
      this.instance = new SharedService();
     }
     return this.instance;
   }

   isLoggedIn(): boolean {
    return false;
   }

}
